<template>
  <div>
    <el-checkbox-group v-model="group">
      <div v-for="(size, id) of sizeDerives" :key="id" :class="innerClass(size)" class="size-item">
        <el-checkbox :label="size">{{ size }}</el-checkbox>
        <span @click.stop="clearAdd(id)"></span>
      </div>

      <el-popover :value="visible" placement="top" trigger="click">
        <div class="size-wrapper">
          <div class="size-input">
            <input-number-plus v-model="width" :max="4" :min="1" :step="1" :width="52" placeholder="请输入" />
            <span>*</span>
            <input-number-plus v-model="height" :max="4" :min="1" :step="1" :width="52" placeholder="请输入" /> (px)
          </div>
          <div class="size-btns">
            <el-button type="primary" style="margin-right: 5px" @click="handleAdd">保存</el-button>
          </div>
        </div>
        <el-button slot="reference" v-if="len < max" type="text" @click.stop="handlePop">+添加其他尺寸</el-button>
      </el-popover>
    </el-checkbox-group>
    <div v-if="!validate" class="g-error-text">尺寸不能为空</div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { setLocal, getLocal } from '@/common/js/api'
import { deepCopy, isEmpty } from '@/common/js/utils'
import InputNumberPlus from '@/components/input/input-number-plus'
export default {
  name: 'DerivesSize',
  components: { InputNumberPlus },
  props: {
    value: {
      type: Array
    },
    max: {
      type: Number
    },
    derives: {
      type: Array
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    group: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    innerClass() {
      return (ret) => {
        return { 'c-del': !this.derives.includes(ret) }
      }
    },
    len() {
      return this.sizeDerives.length
    },
    validate() {
      return this.verify ? Boolean(this.value.length) : true
    }
  },
  data() {
    return {
      visible: false,
      maxWidth: 1920,
      width: '',
      height: '',
      sizeDerives: []
    }
  },
  created() {
    const account = Cookies.get('ch_op_id')
    const storage = getLocal('custom-derives') || {}
    const custom = (account && storage[account]) || []
    const origin = deepCopy(this.derives)
    this.sizeDerives = [...origin, ...custom]
  },
  methods: {
    handlePop() {
      this.width = ''
      this.height = ''
      // this.visible = true
    },
    handleAdd() {
      if (isEmpty(this.width) || isEmpty(this.height) || !this.width || !this.height) {
        this.$Message.error('衍生尺寸不能为空，且不能为0')
        return
      }
      if (this.width % 2 !== 0 || this.height % 2 !== 0) {
        this.$Message.error('衍生尺寸像素值必须为偶数')
        return
      }
      if (this.width > this.maxWidth || this.height > this.maxWidth) {
        this.$Message.error(`衍生尺寸最大值不能大于${this.maxWidth}像素`)
        return
      }
      const val = `${this.width}*${this.height}`
      if (this.sizeDerives.indexOf(val) > -1) {
        this.$Message.error('该衍生尺寸已存在！请更改')
        return
      }
      this.sizeDerives.push(val)
      this.visible = false
      this.setOperatorStorage()
    },
    clearAdd(index) {
      this.sizeDerives.splice(index, 1)
      this.setOperatorStorage()
    },
    setOperatorStorage() {
      const value = this.sizeDerives.filter((ret) => !this.derives.includes(ret))
      const account = Cookies.get('ch_op_id')
      if (account) {
        const storage = getLocal('custom-derives') || {}
        if (value.length) storage[account] = value
        else delete storage[account]
        setLocal('custom-derives', storage)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.size-item {
  display: inline-block;
  min-width: 103px;
  margin-right: 10px;
  padding: 2px 0 2px 3px;

  &.c-del {
    position: relative;
    border-radius: 4px;
    border: solid 1px #fff;

    > span {
      display: flex;
      width: 10px;
      height: 10px;
      background-color: #ff0000;
      border-radius: 20px;
      position: absolute;
      top: -4px;
      right: -4px;
      visibility: hidden;
      align-items: center;
      justify-content: center;

      &::before {
        content: 'x';
        color: #fff;
        display: inline-block;
        font-family: 'element-icons';
        font-size: smaller;
        transform: translateY(-1px);
      }
    }

    &:hover {
      border-color: #1890ff;

      > span {
        cursor: pointer;
        visibility: visible;
      }
    }
  }
}

.size-wrapper {
  display: flex;
  justify-content: space-between;
  .el-button {
    margin-left: 10px;
  }
}
</style>
